<template>
    <div>
        <b-card no-body class="p-1 mb-1">
            <div class="row align-items-center">
                <div class="col-md-2 mb-1 mb-md-0">
                    <label class="form-label">Ay</label>
                    <select class="form-control bg-img-none" v-model="donem.month">
                        <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
                    </select>
                </div>
                <div class="col-md-2 mb-1 mb-md-0">
                    <label class="form-label">Yıl</label>
                    <select class="form-control bg-img-none" v-model="donem.year">
                        <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                    </select>
                </div>
                <div class="col-md-5 mb-1 mb-md-0">
                    <label class="form-label">Maaş Grubu <span class="text-danger">*</span></label>
                    <v-select-list :options="employeeSalaryGroups" label="Value" v-model="employeeSalaryGroupId" placeholder="Maaş grubu seçin"></v-select-list>
                </div>
            </div>
        </b-card>

        <b-card no-body class="mb-1">
            <v-table    ref="table"
                        :fields="fields"
                        with-items
                        :items="datas"
                        pagination="client"
                        :settings="false">
                <template #additional-actions>
                    <div class="row align-items-center">
                        <div class="col-md-3 mb-1 mb-md-0">
                            <b-input-group class="input-group-merge">
                                <template #prepend>
                                    <b-input-group-text>
                                        <feather-icon icon="SearchIcon"></feather-icon>
                                    </b-input-group-text>
                                </template>
                                <b-form-input placeholder="Ara..." v-on:keyup.enter="getData" v-model="searchValue"></b-form-input>
                            </b-input-group>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-success" v-on:click="getData">Sorgula</button>
                        </div>
                        <div class="col-md-auto ml-auto">
                            <button v-if="excelPath" class="btn btn-primary" v-on:click="downloadExcel">
                                <feather-icon icon="FileIcon" class="mr-50"></feather-icon>
                                Excel İndir
                            </button>
                        </div>
                    </div>
                </template>
            </v-table>
        </b-card>
    </div>
</template>

<script>
import moment from 'moment'
import EmployeeOperationsApi from '@/api/employee-operations'
import { BCard, BInputGroup, BInputGroupText, BFormInput } from 'bootstrap-vue';
import Additional from '@/utilities/additional'

export default {
    components: {
        BCard,
        BInputGroup,
        BInputGroupText,
        BFormInput
    },
    data() {
        return {
            searchValue: '',
            excelPath: null,
            datas: [],
            employeeSalaryGroups: [],
            employeeSalaryGroupId: null,
            donem: {
                year: moment().year(),
                month: moment().month() + 1
            },
            months: [
                { index: 1, name: 'Ocak' }, { index: 2, name: 'Şubat' }, { index: 3, name: 'Mart' },
                { index: 4, name: 'Nisan' }, { index: 5, name: 'Mayıs' }, { index: 6, name: 'Haziran' },
                { index: 7, name: 'Temmuz' }, { index: 8, name: 'Ağustos' }, { index: 9, name: 'Eylül' },
                { index: 10, name: 'Ekim' }, { index: 11, name: 'Kasım' }, { index: 12, name: 'Aralık' }
            ],
            years: [],
            // Referans "Ek Hakediş Ekranı" sekmesi (13 kolon). Yemek/Yol Ücreti [Toplam] = ((Y1+Y2)/30×Gün)/30×(N+H).
            fields: [
                {
                    name: '',
                    children: [
                        { name: 'Sıra', key: 'Order', tdClass: 'text-nowrap text-center' },
                        { name: 'İsim Soyisim', key: 'FullName', tdClass: 'text-nowrap', sticky: true },
                        { name: 'TC', key: 'IdentityNumber', tdClass: 'text-nowrap' },
                        { name: 'Şube [Fiili]', key: 'ORGANIZASYONEL_SUBEStr', tdClass: 'text-nowrap', tooltip: 'Personelin en güncel organizasyonel (fiili) şubesi.' },
                        { name: 'Unvan', key: 'GarageOrTitle', tdClass: 'text-nowrap' },
                    ]
                },
                {
                    name: 'Yemek',
                    thClass: 'bg-light-secondary',
                    children: [
                        { name: 'Yemek 1', key: 'ALLOWANCE_YEMEK1Str', tdClass: 'text-right text-nowrap border-left', thClass: 'vt-th-text-right text-secondary', tooltip: 'Maaş Bilgileri 2 → Ek Hakediş: Yemek 1 (HRConstants YEMEK_1 snapshot).' },
                        { name: 'Yemek 2', key: 'ALLOWANCE_YEMEK2Str', tdClass: 'text-right text-nowrap', thClass: 'vt-th-text-right text-secondary', tooltip: 'Maaş Bilgileri 2 → Ek Hakediş: Yemek 2 (serbest girişli).' },
                        { name: 'Yemek Hakediş Günü', key: 'ALLOWANCE_YEMEK_GUNStr', tdClass: 'text-right text-nowrap', thClass: 'vt-th-text-right text-secondary', tooltip: 'Maaş Bilgileri 2 → Ek Hakediş: Yemek hakediş günü.' },
                        { name: 'Yemek Ücreti [Toplam]', key: 'YEMEK_UCRETIStr', tdClass: 'text-right text-nowrap border-right', thClass: 'vt-th-text-right text-secondary', tooltip: 'Yemek Ücreti [Toplam] = ((Yemek1 + Yemek2) ÷ 30 × Yemek Gün) ÷ 30 × (N + H). N = Normal, H = Hafta Tatili gün sayısı.' },
                    ]
                },
                {
                    name: 'Yol',
                    thClass: 'bg-light-info',
                    children: [
                        { name: 'Yol 1', key: 'ALLOWANCE_YOL1Str', tdClass: 'text-right text-nowrap border-left', thClass: 'vt-th-text-right text-info', tooltip: 'Maaş Bilgileri 2 → Ek Hakediş: Yol 1 (HRConstants YOL_1 snapshot).' },
                        { name: 'Yol 2', key: 'ALLOWANCE_YOL2Str', tdClass: 'text-right text-nowrap', thClass: 'vt-th-text-right text-info', tooltip: 'Maaş Bilgileri 2 → Ek Hakediş: Yol 2 (serbest girişli).' },
                        { name: 'Yol Hakediş Günü', key: 'ALLOWANCE_YOL_GUNStr', tdClass: 'text-right text-nowrap', thClass: 'vt-th-text-right text-info', tooltip: 'Maaş Bilgileri 2 → Ek Hakediş: Yol hakediş günü.' },
                        { name: 'Yol Ücreti [Toplam]', key: 'YOL_UCRETIStr', tdClass: 'text-right text-nowrap border-right', thClass: 'vt-th-text-right text-info', tooltip: 'Yol Ücreti [Toplam] = ((Yol1 + Yol2) ÷ 30 × Yol Gün) ÷ 30 × (N + H). N = Normal, H = Hafta Tatili gün sayısı.' },
                    ]
                }
            ]
        }
    },
    computed: {
        filter() {
            return {
                Month: this.donem.month,
                Year: this.donem.year,
                EmployeeSalaryGroupId: this.employeeSalaryGroupId?.Key || null
            }
        }
    },
    mounted() {
        this.configureYears()
        this.getEmployeeSalaryGroups()
    },
    methods: {
        configureYears() {
            let years = []
            let year = moment().add(1, 'year').format('YYYY')
            let firstYear = 2020
            while (firstYear <= year) {
                years.push(firstYear++)
            }
            this.years = years.reverse()
        },
        getEmployeeSalaryGroups() {
            EmployeeOperationsApi.SalaryGroup.List().then(res => {
                this.employeeSalaryGroups = res.data
            })
        },
        getData() {
            if (!this.employeeSalaryGroupId) {
                this.$result({ data: { Success: false, Message: 'Lütfen bir maaş grubu seçin.' } })
                return
            }
            this.$refs.table.setLoading(true)
            EmployeeOperationsApi.GSalary.EkHakedisReport({
                ...this.filter,
                PaginateRequest: {
                    QueryParam: this.searchValue
                }
            }).then(res => {
                if (res.data.Success) {
                    this.datas = res.data.Data.Data?.map((d, i) => ({ Order: i + 1, ...d }))
                    this.excelPath = res.data.Data.ExcelPath
                } else {
                    this.$result(res)
                }
                this.$refs.table.setLoading(false)
            }).catch(err => {
                this.$result(null, err)
                this.$refs.table.setLoading(false)
            })
        },
        downloadExcel() {
            if (this.excelPath) {
                Additional.DownloadTab(this.excelPath)
            }
        }
    }
}
</script>
